<template>
  <div class="my-10 container__div">
    <div class="py-3 text-white">
      <h3>Detalle de la orden</h3>
    </div>
    <div class="py-3">
      <div class="flex">
        <div
          class="mr-4 bg-white w-1/5 text-dark-purple flex justify-center py-5 font-neue"
        >
          Órden: {{ order.id }}
        </div>
        <div
          class="bg-ligth-grey font-neue px-4 items-center justify-between text-white w-2/5 flex py-5"
        >
          <div class="flex items-center">
            <img
              class="h-6 pr-2"
              :src="require('@/assets/img/Icons/wheel.png')"
              alt="precio"
            />
            <span>
              {{ order.vehicle }}
            </span>
          </div>
          <div class="flex items-center">
            <img
              class="h-6 pr-2"
              :src="require('@/assets/img/Icons/monedas.png')"
              alt="precio"
            />
            <span>
              {{ toPEN(order.amount) }}
            </span>
          </div>
          <div class="flex items-center">
            <img
              class="h-6 pr-2"
              :src="require('@/assets/img/Icons/cajita.png')"
              alt="servicio"
            />
            <span>
              {{ order.service }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="mt-3 bg-light-purple uppercase text-dark-purple w-2/5 py-3 px-3 flex justify-between"
      >
        <span> Estado: </span>
        <span class="font-neue">
          {{ order.status }}
        </span>
      </div>
    </div>
    <h4 class="text-white mb-4">Destinos</h4>
    <div class="flex justify-center" style="width: 100%">
      <el-table ref="multipleTable" :data="order.points" style="width: 100%">
        <el-table-column label="Fecha">
          <template slot-scope="scope">
            {{ toDate(scope.row.updatedAt) }}
          </template>
        </el-table-column>
        <el-table-column label="Estado">
          <template slot-scope="scope">
            {{ scope.row.statePoint }}
          </template>
        </el-table-column>
        <el-table-column label="Direccion" width="200">
          <template slot-scope="scope">
            {{ scope.row.fullAddress }}
          </template>
        </el-table-column>
        <el-table-column label="Contacto" width="120">
          <template slot-scope="scope">
            {{ scope.row.contact.name }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
moment.locale("es");

export default {
  data() {
    return {
      order: {},
      points: [],
      errorMessage: "",
      route: "Enviados a Nirex",
    };
  },
  mounted() {
    this.getOrders();
  },
  methods: {
    async getOrders() {
      try {
        const id = this.$route.params.id;
        const response = await axios.get(
          `https://api-staging.nirex.pe/api/orders/${id}`,
          {
            headers: {
              Key: "69a92ae5-a860-411b-8745-6de5016db145",
              "Content-Type": "application/json",
            },
          }
        );
        this.order = response.data[0];
      } catch (error) {
        if (error.response.status === 400) {
          this.errorMessage = error.response.data.errors[0].msg;
        }
      }
    },
    toPEN(cents) {
      return "S/." + (cents / 100.0).toFixed(2);
    },
    toDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>
<style lang="scss">
.el-select {
  margin-top: 20px;
  width: 500px;
  margin-left: 40px;
}

.container__div {
  max-width: 1360px;
  margin: 0 auto;

  @media only screen and (max-width: 1361px) {
    padding: 0 4%;
  }
}
</style>
